import { render, staticRenderFns } from "./NewMaxRanking.vue?vue&type=template&id=dab046ee&scoped=true&"
import script from "./NewMaxRanking.vue?vue&type=script&lang=js&"
export * from "./NewMaxRanking.vue?vue&type=script&lang=js&"
import style0 from "./NewMaxRanking.vue?vue&type=style&index=0&id=dab046ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab046ee",
  null
  
)

export default component.exports